import Metric from "../../../shared/models/metric";
import { UserProfileDTO } from "../../admin/user/user-admin.model";
import { WallboardSlide } from "../wallboards.model";

export class WVBase {
    Slide: WallboardSlide;
}

export class WVData extends WVBase {
    Data: any = [];
}

export class WVMain {
    WallboardCreatorID: number = 0;
    CurrentSlide: number = -1;
    NextSlide: number = -1;
    NextSlideReady: boolean = false;
    RunSlide: boolean = false;
    SkipNextSlide: boolean = false;
    LocalMessages: string = null;
    FirstSlideReady: boolean = false;
    Slides: WallboardSlide[] = [];
}

export class WVCustom extends WVBase {
    ReadyModules: any = [];
    cellHeight: number;
    cellWidth: number;
}

export class WVRacing extends WVBase {
    Data: any = [];
    State: any = {};
}

export interface MetricData {
    AlertThreshold: number;
    Bound: number;
    DenominatorValue: number;
    Direction: number;
    HasPO: boolean;
    MetricDisplayValue: string;
    MetricID: number;
    MetricValue: number;
    NumeratorValue: number;
    POPercent: number;
    ThresholdPercent: number;
    UseDenominator: boolean;
    Value: number;
    formatCurrentStateTime: boolean;
    isMax: boolean;
    objectiveData: any;
}

export class WallboardInfoObj {
    WallboardCreatorID: number;
    WallboardSlides: WallboardSlide[];
}

export interface RacingModuleDataObj {
    groupName: string;
    percentage: number;
    metricData: MetricData;
    targetDisplayValue: number;
}

export interface SummaryModuleDataApiModel {
    Summary_Module_Data_List: any[]; //SummaryModuleDataObj[]
    Has_Current_Metric: boolean;
    DateRange: string;
}

export interface spotlightDataObj {
    Badges: RuleLevelBadge[];
    UserProfile: UserProfileDTO;
    imgID: number;
    useAvatar: boolean;

    Bio?: string;
    imgString: string;
}

export interface GaugeModuleDataApiModel {
    Metric: Metric;
    Metric_Data: MetricData;
    Has_Current_Metric: boolean;
    DateRange: string;
}

export interface ThermometerModuleDataApiModel {
    Metric_Data: MetricData;
    Has_Current_Metric: boolean;
    DateRange: string;
}

export interface RuleLevelBadge {
    LevelBadgeID: number;
    RuleLevelID: number;
    RuleID: number;
    CompanyID: number;
    BadgeLevelName: string;
    ImageID: number;
    ImagePath: string;
    IsDeleted: boolean;
    DateAdded: Date;
    DateRemoved: Date;
    Timestamp: Date;
    GivenByName: string;
    RuleType: number;
    GameType: number;
    AllRolesSelected: boolean;
}

export interface AchievementModuleDataObj {
    activityText: string;
    itemDate: Date;
    activityTitle: string;
    loginID: number;
    loginName: string;
    useAvatar: boolean;
    iconImageID: number;
    imgID: number;
}

export interface TopModuleDataObj {
    groupName: string;
    imgID: number;
    imgString: string;
    metricData: MetricData;
    useAvatar: boolean;
}

export interface AgentCounterModuleDataObj {
    TotalCount: number;
    AvailableCount: number;
    UnavailableCount: number;
    InboundCount: number;
    OutboundCount: number;
    AcwCount: number;
    AgentStateCategories: Map<string, string>;
}

export interface CurrentAgentStatesModuleDataObj {
    callDirection:string;
    groupName:string;
    stateName:string;
    stateTime:string;
    isACW:string;
    OnCall: any[]; //CurrentAgentStatesLineItemObj[]
    Unavailable: any[]; //CurrentAgentStatesLineItemObj[]
    Available: any[]; //CurrentAgentStatesLineItemObj[]
    InboundCount: number;
    OutboundCount: number;
    UnavailableCount: number;
    AvailableCount: number;
    TotalCount: number;
    CallsInQueueCount: number;
    LongestCallInQueue; //TimeSpan
    LongestCallInQueueFormatted: string;
    AgentStateCategories: Map<string, string>;
}
